var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21747 6.21967C6.51037 5.92678 6.98524 5.92678 7.27813 6.21967L11.998 10.9395L16.7175 6.22004C17.0104 5.92715 17.4852 5.92715 17.7781 6.22004C18.071 6.51294 18.071 6.98781 17.7781 7.2807L13.0586 12.0002L17.7777 16.7192C18.0706 17.0121 18.0706 17.487 17.7777 17.7799C17.4848 18.0728 17.0099 18.0728 16.717 17.7799L11.998 13.0608L7.27856 17.7803C6.98567 18.0732 6.51079 18.0732 6.2179 17.7803C5.92501 17.4874 5.92501 17.0125 6.2179 16.7196L10.9373 12.0002L6.21747 7.28033C5.92458 6.98744 5.92458 6.51256 6.21747 6.21967Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.9ab8c5e198575ca4e4cd042f2def0eae.svg";
export { ForwardRef as ReactComponent };